export default __webpack_public_path__ + "static/media/hashtag-icon.fd5aa9a2.svg";